<div class="tasks-container" [ngClass]="{ 'sidebar-open': sideComponentOpen }">
  <p class="tab-title">{{ activeTab === 'Tasks' ? 'Pending Tasks' : 'Task History' }}</p>

  <!-- Task Tabs Content -->
  @if (activeTab === 'Tasks') {
    <div class="tab-content" *appHasPermission="{ resource: Resources.Tasks, scope: Scopes.Read }">
      <app-tasks-tab
        (taskSelected)="onTaskSelected($event)"
        (tasksLoaded)="onTasksLoaded($event)"
        [updateTick]="updateTick"
        [searchText]="tasksSearchText"
        [targetTaskId]="targetTaskId"
        />
    </div>
  }

  <!-- History Tab Content -->
  @if (activeTab === 'History') {
    <div class="tab-content" *appHasPermission="{ resource: Resources.Tasks, scope: Scopes.History }">
      <app-tasks-history
        (taskSelected)="onHistoryTaskSelected($event)"
        [targetTaskHistoryId]="targetTaskHistoryId"
        [searchText]="historySearchText"
        />
    </div>
  }
</div>

<!-- Task details aside -->
@if (sidebarOpen && selectedTask) {
  <div class="task-details-aside" animate.enter="slide-in-right-ease-in" animate.leave="slide-out-right">
    <app-task-details
      [task]="selectedTask"
      [taskDetail]="selectedTaskDetail"
      (closed)="closeTaskDetails()"
      (taskUpdated)="onTaskUpdated()"
      />
  </div>
}
